/**
 * Generato automaticamente.
 * OpenAPI
 */

export type EnumModuloDTONecessitaFirma =
  (typeof EnumModuloDTONecessitaFirma)[keyof typeof EnumModuloDTONecessitaFirma];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumModuloDTONecessitaFirma = {
  NO: 'NO',
  SI: 'SI',
  SI_SE_NON_TITOLARE: 'SI_SE_NON_TITOLARE',
} as const;
